﻿/* Code used for the newsletter subscribe in footer, but also on the /subscribe and /unsubscribe pages */
namespace eXpress.web.Newsletter {
	const subscriptionForms = html.querySelectorAll<HTMLElement>(document, ".technical-newsletter-subscribe");
	const subscribeAsync = (email: string, appId: string, posId: string, lang: string, source?: string) =>
		$.ajax({
			type: "POST",
			url: "/api/v1/AccountService.svc/json/Subscribe",
			data: JSON.stringify({
				applicationId: appId,
				pointOfSaleId: posId,
				language : lang,
				email,
				source,
				newsletter: true
			}),
			contentType: "application/json; charset=utf-8",
			dataType: "json"
		}).then(res => {
			// 
		}) as JQueryPromise<void>;

	let ioSubscribe: IntersectionObserver;

	if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in (window as any).IntersectionObserverEntry.prototype)) {
		ioSubscribe = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						eXpress.components.main.createNewsletterSubscribe(entry.target as HTMLElement,
							{
								subscribeAsync
							});
						observer.unobserve(entry.target);
					}
				});
			},
			{ rootMargin: "0px 0px 0px 0px" }
		);
		subscriptionForms.forEach(el => ioSubscribe.observe(el));
	} else {
		subscriptionForms.forEach(formEL => {
			eXpress.components.main.createNewsletterSubscribe(
				formEL,
				{
					subscribeAsync
				});
		});
	}

	const toggleSubscribeAsync = (personId: string, email: string, appId: string, posId: string, lang: string, source?: string, newsletter?: boolean, personalMessage?: boolean, mailFrequency?: number, postalMail?: boolean) => {
		const toggleSubscription = {
			personId,
			applicationId: appId,
			pointOfSaleId: posId,
			language: lang,
			email,
			source,
			newsletter,
			personalMessage,
			mailFrequency,
			postalMail
		};

		return $.ajax({
			type: "POST",
			url: `${window.context.ecomApiUrl}/subscriptions/togglesubscribe`,
			data: JSON.stringify(toggleSubscription),
			contentType: "application/json; charset=utf-8",
			dataType: "json"
		}).then(() => {
			// nothing
		});
	};

	let ioUnSubscribe: IntersectionObserver;
	const unSubscriptionForms = html.querySelectorAll<HTMLElement>(document, ".technical-newsletter-unsubscribe");
	if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in (window as any).IntersectionObserverEntry.prototype)) {
		ioUnSubscribe = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						eXpress.components.main.createNewsletterUnsubscribe(entry.target as HTMLElement,
							{
								toggleSubscribeAsync
							});
						observer.unobserve(entry.target);
					}
				});
			},
			{ rootMargin: "0px 0px 0px 0px" }
		);
		unSubscriptionForms.forEach(el => ioUnSubscribe.observe(el));
	} else {
		unSubscriptionForms.forEach(formEL => {
			eXpress.components.main.createNewsletterUnsubscribe(
				formEL,
				{
					toggleSubscribeAsync
				});
		});
	}
}
